module.exports = "label::first-letter {\n  text-transform: capitalize; }\n"